{
  "availableBalance": "可用余额",
  "lockedQuantity": "锁定数量",
  "deposit": "收币",
  "assetDetails": "资产明细",
  "filter": {
    "all": "全部",
    "deposit": "收币",
    "swap": "闪兑",
    "payment": "支付",
    "buyCoin": "买币",
    "sellCoin": "卖币",
    "return": "奖励",
    "others": "其他"
  }
}
